import React from "react";
import { Row, Col } from "antd";
import StrippingScheduleForm from "./StrippingScheduleForm/StrippingScheduleForm";

export interface Props {
    children?: React.ReactNode
    homePageIsStarted?: boolean;
}

export interface State {
}

export default class StrippingSchedule extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
        }
    }

    render() {
        return (
            <div>
                <Row gutter={24} style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "5px" }}>
                    <Col className="col-2">
                        <StrippingScheduleForm homeMode={this.props.homePageIsStarted} {...this.props} />
                    </Col>
                </Row>
            </div>
        )
    }
}